// Small fetch wrapper that always sends credentials for the admin session cookie.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

async function req(method, path, body, opts = {}) {
  const res = await fetch(`${API}${path}`, {
    method,
    credentials: 'include',
    headers: body ? { 'Content-Type': 'application/json' } : {},
    body: body ? JSON.stringify(body) : undefined,
  });
  const ctype = res.headers.get('content-type') || '';
  const data = ctype.includes('application/json') ? await res.json() : await res.text();
  if (!res.ok) {
    // Prefer backend's detail message; fall back to a generic HTTP-status label.
    let detail = typeof data === 'object' ? data?.detail : data;
    if (Array.isArray(detail)) {
      detail = detail.map((e) => (e && typeof e.msg === 'string' ? e.msg : JSON.stringify(e))).filter(Boolean).join(' ');
    }
    if (!detail || typeof detail !== 'string') {
      if (res.status === 401) detail = opts.silentUnauthed ? 'Not authenticated' : 'Please sign in.';
      else if (res.status === 429) detail = 'Too many attempts. Please wait a few minutes.';
      else detail = 'Request failed';
    }
    const err = new Error(detail);
    err.status = res.status;
    throw err;
  }
  return data;
}

export const adminApi = {
  // Used by ProtectedAdminRoute — swallow "Not authenticated" so it never
  // leaks into a user-facing error slot on the login page.
  me: () => req('GET', '/admin/me', undefined, { silentUnauthed: true }),
  login: (email, password) => req('POST', '/admin/login', { email, password }),
  logout: () => req('POST', '/admin/logout'),
  registerViaInvite: (token, email, password) =>
    req('POST', '/admin/register', { token, email, password }),
  forgotPassword: (email) => req('POST', '/admin/forgot-password', { email }),
  changePassword: (current_password, new_password) =>
    req('POST', '/admin/change-password', { current_password, new_password }),
  overview: () => req('GET', '/admin/overview'),
  listLeads: (params = {}) => {
    const qs = new URLSearchParams(
      Object.entries(params).filter(([, v]) => v !== undefined && v !== '' && v !== null)
    ).toString();
    return req('GET', `/admin/leads${qs ? `?${qs}` : ''}`);
  },
  exportLeadsCsvUrl: () => `${API}/admin/leads-export.csv`,
  getSiteConfig: () => req('GET', '/admin/site-config'),
  saveSiteConfig: (payload) => req('PUT', '/admin/site-config', payload),
};

// Robots meta helper for admin pages
export function setNoindex() {
  const existing = document.querySelector('meta[name="robots"]');
  if (existing) existing.remove();
  const meta = document.createElement('meta');
  meta.name = 'robots';
  meta.content = 'noindex,nofollow,noarchive,nosnippet';
  document.head.appendChild(meta);
  return () => meta.remove();
}
